module.exports = "../images/cabin2-v2.jpg?v=37c7872";